import { render, staticRenderFns } from "./SlimContainerWithTopMarginWhiteBg.vue?vue&type=template&id=3084f2c1&"
import script from "./SlimContainerWithTopMarginWhiteBg.vue?vue&type=script&lang=js&"
export * from "./SlimContainerWithTopMarginWhiteBg.vue?vue&type=script&lang=js&"
import style0 from "./SlimContainerWithTopMarginWhiteBg.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3084f2c1')) {
      api.createRecord('3084f2c1', component.options)
    } else {
      api.reload('3084f2c1', component.options)
    }
    module.hot.accept("./SlimContainerWithTopMarginWhiteBg.vue?vue&type=template&id=3084f2c1&", function () {
      api.rerender('3084f2c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/wrappers/SlimContainerWithTopMarginWhiteBg.vue"
export default component.exports